import GetElSlots from '../scripts/mixins/get-el-slots';
import TenIcon from '../icon';
import renderCell from '../render-cell';
import Emitter from '../scripts/mixins/emitter';

const name = 'ten-tabs';

export default {
  name,
  components: {
    TenIcon,
    renderCell,
  },
  mixins: [GetElSlots, Emitter],
  props: {
    /**
     * 当前选中的值
     */
    value: [String, Number],
    /**
     * tabs 主题
     * @member normal | primary
     */
    type: String,
    /**
     * 是否需要 lazyload
     */
    lazy: Boolean,
  },
  provide() {
    return {
      tabs: this,
    };
  },
  data() {
    const curValue = this.value;
    return {
      navList: [],
      curValue,
      scrollShow: false,
      scrollLeft: 0,
    };
  },
  computed: {
    _class() {
      return [
        name,
        {
          [`ten-tabs--${this.type}`]: this.type,
        },
      ];
    },
    _navClass() {
      return [`${name}-nav`];
    },
    _contentClass() {
      return [`${name}-content`];
    },
  },
  watch: {
    value(v) {
      this.curValue = v;
      this.scrollTabIntoView(v);
    },
  },
  created() {
    this.updateNavListT = 0;
    this.refreshScrollT = 0;
  },
  mounted() {
    window.addEventListener('resize', this.setNavScroll, false);
    this.updateNavList();
    this.$on('pane-updated', this.onPaneUpdate);
    const navList = this.getNavList();
    if (typeof this.value === 'undefined' && navList[0]) {
      this.curValue = navList[0]._dataValue;
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setNavScroll);
    this.$off('pane-updated', this.onPaneUpdate);
    clearTimeout(this.updateNavListT);
    clearTimeout(this.refreshScrollT);
  },
  render() {
    return (
      <div class={this._class}>
        <div class={this._navClass} ref='tabNav'>
          <div
            class='ten-tabs-nav-scroll'
            ref='navScroll'
            style={{ transform: `translateX(${-this.scrollLeft}px)` }}
          >
            {this.navList.map(item => this.renderNavItem(item))}
          </div>
          {this.scrollLeft > 0 && (
            <div
              class='ten-tabs-scroll__prev'
              on-click={() => this.onScrollBtnClick(true)}
            >
              <TenIcon icon='left' />
            </div>
          )}
          {this.scrollShow && (
            <div
              class='ten-tabs-scroll__next'
              on-click={() => this.onScrollBtnClick(false)}
            >
              <TenIcon icon='right' />
            </div>
          )}
        </div>

        <div class={this._contentClass}>
          {this.$scopedSlots.default && this.$scopedSlots.default()}
          <slot />
        </div>
      </div>
    );
  },
  methods: {
    renderNavItem(navItem) {
      let icon;
      if (navItem.closeTab || navItem.closable) {
        icon = (
          <TenIcon on-click={e => this.onClose(navItem, e)} icon='clear' />
        );
      } else if (navItem.icon) {
        icon = <TenIcon icon={navItem.icon} />;
      } else if (navItem.$slots.icon) {
        icon = navItem.$slots.icon; // eslint-disable-line
      }
      return (
        <span
          class={this.getNavItemClass(navItem)}
          key={navItem._dataValue}
          on-click={e => this.onNavItemClick(navItem, e)}
          ref={`tab-${navItem.value}`}
        >
          {navItem.$slots.label || navItem.label}
          <span class="ten-tabs-tab__icon">{icon}</span>
        </span>
      );
    },
    updateNavList() {
      clearTimeout(this.updateNavListT);
      this.updateNavListT = setTimeout(() => {
        const navList = this.getNavList();
        this.navList = navList;
        this.setNavScroll();
        clearTimeout(this.refreshScrollT);
        this.refreshScrollT = setTimeout(() => {
          this.setNavScroll();
        });
      });
    },
    // 获取导航数据
    getNavList() {
      if (!this.$scopedSlots.default) {
        return [];
      }
      const defaultSlots = this.$scopedSlots.default();
      return defaultSlots
        .map((vnode) => {
          if (
            vnode.componentOptions
            && vnode.componentOptions.Ctor.options.name === 'ten-tabs-pane'
          ) {
            return vnode.componentInstance;
          }
          return undefined;
        })
        .filter(v => v);
    },
    // 获取导航样式
    getNavItemClass(navItem) {
      const { _dataValue, disabled, information, closeTab, icon } = navItem;
      return [
        `${name}-tab`,
        {
          [`${name}-tab--active`]: _dataValue === this.curValue,
          [`${name}-tab--disabled`]: disabled,
          [`${name}-tab--info`]: information || information === '',
          [`${name}-tab--icon`]: icon || navItem.$slots.icon,
          [`${name}-tab--close`]: closeTab || closeTab === '',
        },
      ];
    },
    setNavScroll() {
      if (!this.$refs.navScroll) return;
      const { navScroll } = this.$refs;
      const { tabNav } = this.$refs;
      const navScrollWidth = navScroll.offsetWidth;
      const tabNavWidth = tabNav.offsetWidth;

      if (navScrollWidth <= tabNavWidth) {
        this.scrollShow = false;
        this.scrollLeft = 0;
      } else {
        if ((navScrollWidth - this.scrollLeft) > tabNavWidth) {
          this.scrollShow = true;
        } else if ((navScrollWidth - this.scrollLeft) <= tabNavWidth) {
          this.scrollShow = false;
        }
      }
    },
    onPaneUpdate() {
      this.updateNavList();
    },
    // 导航点击
    onNavItemClick(navItem) {
      /**
       * tab 点击事件回调函数
       */
      this.$emit('click-tab', navItem._dataValue);
      this.$emit('change', navItem._dataValue);
      this.broadcastAll('do-layout');
    },
    // 点击关闭
    onClose(navItem, e) {
      /**
       * tab 删除事件回调函数
       */
      this.$emit('close-tab', navItem._dataValue);
      e.stopPropagation();
    },
    // 滚动按钮
    onScrollBtnClick(lr) {
      const navWidth = this.$refs.tabNav.offsetWidth;
      const scrollWidth = this.$refs.navScroll.offsetWidth;
      const removeLeft = this.type ? 220 : 100;
      let attribute = this.scrollLeft + (lr ? -navWidth + removeLeft : navWidth - removeLeft);

      if (attribute < 0) attribute = 0;
      if (attribute + navWidth > scrollWidth) {
        attribute = scrollWidth - navWidth;
      }

      this.scrollLeft = attribute;
      this.scrollShow = attribute + navWidth !== scrollWidth;
    },
    scrollTabIntoView(val) {
      const { tabNav } = this.$refs;
      const activeTab = this.$refs[`tab-${val}`];
      if (!tabNav || !activeTab) return;

      const navWidth = tabNav.offsetWidth;
      const tabOffsetLeft = activeTab.offsetLeft;
      const tabOffsetWidth = activeTab.offsetWidth;
      const scrollBtnWidth = 41;

      if (tabOffsetLeft <= this.scrollLeft + scrollBtnWidth) {
        this.scrollLeft = Math.max(tabOffsetLeft - tabOffsetWidth - scrollBtnWidth, 0);
      } else if ((tabOffsetLeft + tabOffsetWidth) >= (this.scrollLeft + navWidth)) {
        this.scrollLeft = tabOffsetLeft - navWidth + tabOffsetWidth;
      }
    },
  },
};
